import type { RefOrGetter } from '@/helpers'
import { ref, type Ref, toValue, watch } from 'vue'

export interface WheelDirection {
    bound: Ref<boolean>
}

export function useWheelDirection(options: {
    container: RefOrGetter<HTMLElement | null>
    callback: (container: HTMLElement, direction: 'up' | 'down') => void
}): WheelDirection {
    const { container: containerRef, callback } = options
    const bound = ref(false)

    function onScroll(e: WheelEvent): void {
        const container = toValue(containerRef)

        if (!container) {
            return
        }

        e.preventDefault()
        callback(container, e.deltaY > 0 ? 'down' : 'up')
    }

    watch(containerRef, (container, oldContainer) => {
        if (container) {
            container.addEventListener('wheel', onScroll, {
                capture: true,
                passive: true,
            })
        }

        bound.value = !!container

        if (oldContainer) {
            oldContainer.removeEventListener('wheel', onScroll)
        }
    })

    return {
        bound,
    }
}
